import type { ReadingCompanionProps } from "@op/puck-types";
import { LazyComponent } from "../../../utils/LazyComponent";

export const ReadingCompanion = (props: ReadingCompanionProps) => {
  return (
    <LazyComponent<ReadingCompanionProps> name="ReadingCompanion" {...props} />
  );
};
